import { useRef, useState, useEffect } from "react";
import IconAudio from "../../component/SvgIcons/IconAudio";
import IconPlay from "../../component/SvgIcons/IconPlay";
import IconPause from "../../component/SvgIcons/IconPause";
import IconMute from "../../component/SvgIcons/IconMuite";
import IconUnMute from "../../component/SvgIcons/IconUnMuite";
import { playNewAudio } from "../../utils/playNewAudioUtil";
import IconNextAudio from "../../component/SvgIcons/IconNextAudio";
import IconPrevAudio from "../../component/SvgIcons/IconPrevAudio";
import IcondownloadAudio from "../../component/SvgIcons/IcondownloadAudio";

function AudioPlayer({ url }) {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const playPromiseRef = useRef(null);

const togglePlay = () => {
  const audio = audioRef.current;
  if (!audio) return;

  if (isPlaying) {
    audio.pause();
    setIsPlaying(false);
  } else {
    playNewAudio(audioRef, setIsPlaying);
  }
};


  // Mute/unmute toggle
  const toggleMute = () => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  // Update current time and duration as audio plays
useEffect(() => {
  const audio = audioRef.current;
  if (!audio) return;

  const handleForcePause = () => {
    audio.pause();
    setIsPlaying(false);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(audio.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(audio.duration || 0);
    setCurrentTime(audio.currentTime);
  };

const handleSeeked = () => {
  setCurrentTime(audio.currentTime);
  setDuration(audio.duration || 0);
};

  // Attach all relevant listeners
  audio.addEventListener("forcePause", handleForcePause);
  audio.addEventListener("timeupdate", handleTimeUpdate);
  audio.addEventListener("loadedmetadata", handleLoadedMetadata);
  audio.addEventListener("seeked", handleSeeked);

  return () => {
    // Cleanup
    audio.removeEventListener("forcePause", handleForcePause);
    audio.removeEventListener("timeupdate", handleTimeUpdate);
    audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
    audio.removeEventListener("seeked", handleSeeked);
  };
}, []);



  // Format seconds to mm:ss
  const formatTime = (time) => {
    if (isNaN(time)) return "00:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  // Skip 5 seconds back safely
const skipBackward = () => {
  const audio = audioRef.current;
  if (!audio || !isFinite(audio.duration)) return;
  audio.currentTime = Math.max(0, audio.currentTime - 5);
};

const skipForward = () => {
  const audio = audioRef.current;
  if (!audio || !isFinite(audio.duration)) return;
  audio.currentTime = Math.min(audio.duration, audio.currentTime + 5);
};

  // Calculate progress (0 to 1)
  const progress = duration ? currentTime / duration : 0;

  // Dynamic progress bar color: green → yellow → red
  const getProgressColor = (progress) => {
    if (progress < 0.5) {
      const green = 255;
      const red = Math.floor(255 * (progress / 0.5));
      return `rgb(${red},${green},0)`; // green to yellow
    } else {
      const red = 255;
      const green = Math.floor(255 * (1 - (progress - 0.5) / 0.5));
      return `rgb(${red},${green},0)`; // yellow to red
    }
  };

  const progressColor = getProgressColor(progress);
useEffect(() => {
  const audio = audioRef.current;
  if (!audio) return;

  const onPlay = () => setIsPlaying(true);
  const onPause = () => setIsPlaying(false);

  audio.addEventListener("play", onPlay);
  audio.addEventListener("pause", onPause);

  return () => {
    audio.removeEventListener("play", onPlay);
    audio.removeEventListener("pause", onPause);
  };
}, []);
const handleDownload = async () => {
  try {
    const response = await fetch(url, { mode: 'cors' }); // use 'cors' or 'no-cors' as needed
    if (!response.ok) throw new Error('Network response was not ok');
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = "audio.mp3"; // your desired file name
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed", error);
  }
};

  return (
    <div className="audioplay d-flex flex-column gap-2 w-100">
      {/* Time + Progress */}
      <div className="d-flex align-items-center gap-2 w-100">
        {/* Full width seek bar */}
        <div
          className="audio-progress-bar position-relative"
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            // const newTime = (clickX / rect.width) * duration;
            // audioRef.current.currentTime = newTime;
            if (isFinite(duration)) {
              audioRef.current.currentTime = (clickX / rect.width) * duration;
            }
 }}
          style={{
            height: "6px",
            background: "#e0e0e0",
            borderRadius: "4px",
            cursor: "pointer",
            width: "100%",
          }}
        >
          <div
            style={{
              height: "100%",
              width: `${progress * 100}%`,
              background: progressColor,
              borderRadius: "4px",
              transition: "width 0.2s ease",
            }}
          />
        </div>
      </div>

      {/* Controls: Prev/Next, Time, Mute, Play */}
      <div className="audio-controls d-flex align-items-center justify-content-between gap-3">
         {/* <button className="btn p-0 tranparenteffect position-relative" onClick={skipBackward}>
           <IconPrevAudio/>
          </button>
          <button className="btn p-0 tranparenteffect position-relative" onClick={skipForward}>
           <IconNextAudio/>
          </button> */}
        <div className="d-flex gap-3">
        <button className="btn p-0 tranparenteffect position-relative" onClick={toggleMute}>
          {isMuted ? <IconMute /> : <IconUnMute />}
        </button>
        <button className="btn p-0 tranparenteffect position-relative" onClick={togglePlay}>
          {isPlaying ? <IconPause /> : <IconPlay />}
        </button>
        </div>

         <div className="text-muted small" style={{ minWidth: 60 }}>
          {formatTime(currentTime)} / {formatTime(duration)}
          </div>
          <button
            onClick={() => window.open(url, '_blank')}
            className="btn p-0 tranparenteffect position-relative"
          >
            <IcondownloadAudio />
          </button>
        
        <audio
        ref={audioRef}
        src={url}
        preload="metadata"
        onEnded={() => setIsPlaying(false)}
      />

      </div>
    </div>
  );
}

export default AudioPlayer;
